const NotFound = () => {
  return (
    <div className="error-container">
      <div className="text-center mt-5">
        <h2 className="text-warning">404</h2>
        <h3>
          <i className="fas fa-exclamation-triangle text-warning" /> Oops! Item
          not found.
        </h3>
        <p>
          We could not find the item you were looking for. Meanwhile, you may{" "}
          <a href="/">return to Home Page</a>.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
